import { render, staticRenderFns } from "./LeadGeneration.vue?vue&type=template&id=a2f91322"
import script from "./LeadGeneration.vue?vue&type=script&lang=js"
export * from "./LeadGeneration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2f91322')) {
      api.createRecord('a2f91322', component.options)
    } else {
      api.reload('a2f91322', component.options)
    }
    module.hot.accept("./LeadGeneration.vue?vue&type=template&id=a2f91322", function () {
      api.rerender('a2f91322', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/reports/LeadGeneration.vue"
export default component.exports